import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { bookingUrl, navLinks } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-40 bg-white/95 backdrop-blur transition-[border-color] duration-200 border-b ${scrolled ? 'border-line' : 'border-transparent'}`} data-id="element-31" data-mp="31byroond15g3">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-6 px-5 lg:px-8" data-id="element-32" data-mp="3ba4wpf4gqrp6">
        <a href="#top" aria-label="Comme un Charme, accueil" data-id="element-33" data-mp="3fbgmplr91exw">
          <Logo data-id="element-34" data-mp="3fbztc6bg8gwm" />
        </a>

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-35" data-mp="2wkuor0melv9g">
          <ul className="flex items-center gap-7" data-id="element-36" data-mp="2wirozovg8nrj">
            {navLinks.map(l => <li key={l.label} data-id="element-37" data-mp="2rkgf5e55md9b">
                <a href={l.href} className="whitespace-nowrap text-[15px] text-muted transition-colors duration-150 hover:text-ink focus-visible:text-ink focus-visible:outline-none" data-id="element-38" data-mp="2mmewgubn4fyd">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-39" data-mp="3adkad3y0sy61">
          <a href={bookingUrl} className="hidden whitespace-nowrap rounded-full bg-sage px-5 py-2.5 text-sm font-bold text-white transition-colors duration-150 hover:bg-sage-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sage sm:inline-block" data-id="element-40" data-mp="35lj01nkexhin">
            Réserver un soin
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="rounded-full p-2 text-ink hover:bg-cream lg:hidden" data-id="element-41" data-mp="3t90q9eo147ji">
            {open ? <XIcon className="h-6 w-6" data-id="element-42" data-mp="1mml77cxv31xj" /> : <MenuIcon className="h-6 w-6" data-id="element-43" data-mp="1mltc0386f67s" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-44" data-mp="18mttzef65pkl">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-white px-5 pb-6 lg:hidden" data-id="element-45" data-mp="18p6e9y8egc0t">
            <ul className="divide-y divide-line" data-id="element-46" data-mp="2t3gcs0spjpsw">
              {navLinks.map(l => <li key={l.label} data-id="element-47" data-mp="2y0p0egwmkm1j">
                  <a href={l.href} onClick={() => setOpen(false)} className="block py-4 font-serif text-2xl text-ink" data-id="element-48" data-mp="2xznne6w1tph6">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}